import { Close } from '@radix-ui/react-dialog';
import clsx from 'clsx';
import Image from 'next/image';

import css from './style.module.scss';

export type CloseIconVariant = 'paint' | 'tapeGray' | 'tapeGrayDark' | 'tapeGreen';

const ICONS_MAP = {
	paint: {
		src: '/assets/images/dialogs/paint-close-icon.svg',
		width: 36,
		height: 36
	},
	tapeGray: {
		src: '/assets/images/dialogs/tape-close-gray.webp',
		width: 46,
		height: 46
	},
	tapeGrayDark: {
		src: '/assets/images/dialogs/tape-close-gray-dark.webp',
		width: 70,
		height: 70
	},
	tapeGreen: {
		src: '/assets/images/dialogs/tape-close-green.webp',
		width: 38,
		height: 40
	}
};

interface Props {
	variant: CloseIconVariant;
	className?: string;
}

const DialogCloseCustomIcon = ({ variant, className }: Props) => {
	const data = ICONS_MAP[variant];

	return (
		<Close className={clsx(css.close, className)}>
			<Image
				className={css.image}
				src={data.src}
				alt="close"
				width={data.width}
				height={data.height}
			/>
		</Close>
	);
};

export default DialogCloseCustomIcon;
